import React from 'react';

// Base
import Placeholder from '../../../../base/placeholder';

// Related Components
import SidebarLoading from './sidebar/loading';

export default class Loading extends React.PureComponent {
  render() {
    return (
      <div className='fixed-width-layout'>
        <div className='sidebar is-sticky'>
          <SidebarLoading />
        </div>
        <div className='content'>
          <Placeholder lines={12} />
        </div>
      </div>
    )
  }
}

